import React from "react";
import { Link } from "react-router-dom";
import CopyableLabel from "../CopyableLabel";

interface TableEntryProps {
  field: string
  value: string
  destination?: string
}

const TableEntry: React.FC<TableEntryProps> = ({ field, value, destination }) => {

  return (
    <td key={field} className="px-4 text-cents-black truncate overflow-hidden border-l border-cents-grey">
      {field !== '_id' ? value : destination ? (
        <Link 
        to={`/${destination}/${value}`}
        target={"_self"}
        className="truncate cursor-pointer overflow-hidden underline text-blue-700">{value}
      </Link>
      ) : (
        <CopyableLabel text={value} />
      )}
    </td>
  )
}

export default TableEntry